import { MOBILE_MAX_WIDTH } from 'constants/styles';

const isMobile = () => window.innerWidth <= MOBILE_MAX_WIDTH;

export default isMobile;
